module.exports = __webpack_public_path__ + "img/datepicker_arrow_left.cdf9e799.svg";